export const numberToString = (value: number) => value.toString();
